module.exports = __webpack_public_path__ + "static/media/scroll3_4.416b375f.png";